export enum OrderStats{
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _5 = 5,
    _7 = 7,
    _8 = 8,
    _9 = 9,
    _10 = 10,

    _110 = 110,
    _220 = 220, // 新单  <=220
    _330 = 330,
    _331 = 331,
    _550 = 550,
    _551 = 551,
    _552 = 552,
    _553 = 553,
    _556 = 556, // 转出方的退回状态
    _771 = 771,
    _772 = 772,
    _773 = 773,
    _774 = 774,
    _775 = 775,
    _880 = 880,
    _990 = 990,
    _991 = 991,
    _992 = 992,
    _1000 = 1000,

    _330110 = 330110,
    _330120 = 330120,
    _330210 = 330210,
    _330230 = 330230,
    _550300 = 550300,
    _550310 = 550310,
    _550320 = 550320,
    _550330 = 550330,
    _550350 = 550350,
    _550390 = 550390,
    _550523 = 550523,
    _550525 = 550525,
    _550533 = 550533,
    _550535 = 550535,
    _550700 = 550700,
    _550701 = 550701,
    _550702 = 550702,
    _550715 = 550715,
    _550725 = 550725,
    _550735 = 550735,
    _550745 = 550745,
    _550910 = 550910,
    _550911 = 550911,
    _550912 = 550912,
    _551920 = 551920,
    _553930 = 553930,
    _880800 = 880800,
}
